import {Controller, useFormContext} from "react-hook-form";
import {Values, Type} from "./PassForm";
import {Card, CardContent, Grid, TextField} from "@mui/material";
import {DateField} from "~/apps/core/ui/DateField";
import {PassportSeriesNumberField} from "~/apps/core/ui/PassportSeriesNumberField";
import React, {useEffect, useMemo} from "react";
import moment from "moment";


export type PassportFormCardProps = {
    types: Type[]
}


export const PassportFormCard = (props: PassportFormCardProps) => {
    const {types} = props;
    const {control, watch, errors} = useFormContext<Values>();
    const now = useMemo(() => new Date(), []);

    useEffect(() => {
        const firstError = (
            Object.keys(errors) as Array<keyof typeof errors>
        ).reduce<keyof typeof errors | null>((field, a) => {
            const fieldKey = field as keyof typeof errors;
            return !!errors[fieldKey] ? fieldKey : a;
        }, null);
        if (firstError === 'passportDate' || firstError === 'birthDate') {
            const field: HTMLInputElement = document.querySelector(
                `input[name="${firstError}"]`
            )
            if (field) field.focus();
        }
    }, [errors])

    return (
        <Card>
            <CardContent>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Controller
                            name="passportSeries"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange: onSeriesChange, value: series}) => (
                                <Controller
                                    name="passportNumber"
                                    control={control}
                                    rules={{required: "Обязательно для заполнения"}}
                                    render={({onChange: onNumberChange, value: number, ref: numberRef, name}) => (
                                        <PassportSeriesNumberField
                                            label="Серия, номер"
                                            fullWidth
                                            value={`${series || ""}${number || ""}`}
                                            onChange={value => {
                                                const newSeries = value ? value.substr(0, 4) : null;
                                                const newNumber = value ? value.substr(4) : null;
                                                if (newSeries != series) {
                                                    onSeriesChange(newSeries);
                                                }
                                                if (newNumber != number) {
                                                    onNumberChange(newNumber)
                                                }
                                            }}
                                            inputRef={numberRef}
                                            error={Boolean(errors?.[name])}
                                            helperText={errors?.[name]?.message}
                                        />
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="passportIssuer"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, ref, name}) => (
                                <TextField
                                    label="Кем выдан"
                                    placeholder="ОУФМС России по Приморскому краю"
                                    fullWidth
                                    inputProps={{maxLength: 128}}
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="passportDate"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, ref, name}) => (
                                <DateField
                                    label="Дата выдачи"
                                    fullWidth
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    ref={ref}
                                    name={name}
                                    maxDate={now}
                                />
                            )}
                        />
                    </Grid>
                    {types.includes("PEDESTRIAN") && (
                        <>
                            <Grid item>
                                <Controller
                                    name="birthDate"
                                    control={control}
                                    rules={{required: "Обязательно для заполнения"}}
                                    render={({onChange, value, ref, name}) => (
                                        <DateField
                                            label="Дата рождения"
                                            fullWidth
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(errors?.[name])}
                                            helperText={errors?.[name]?.message}
                                            ref={ref}
                                            name={name}
                                            maxDate={now}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item>
                                <Controller
                                    name="birthPlace"
                                    control={control}
                                    rules={{required: "Обязательно для заполнения"}}
                                    render={({onChange, value, ref, name}) => (
                                        <TextField
                                            label="Место рождения"
                                            placeholder="г. Владивосток"
                                            fullWidth
                                            inputProps={{maxLength: 128}}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(errors?.[name])}
                                            helperText={errors?.[name]?.message}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item>
                                <Controller
                                    name="registrationAddress"
                                    control={control}
                                    rules={{required: "Обязательно для заполнения"}}
                                    render={({onChange, value, ref, name}) => (
                                        <TextField
                                            label="Адрес регистрации"
                                            placeholder="г. Владивосток, ул. Стрельникова 9"
                                            fullWidth
                                            inputProps={{maxLength: 128}}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(errors?.[name])}
                                            helperText={errors?.[name]?.message}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item>
                                <Controller
                                    name="actualAddress"
                                    control={control}
                                    rules={{required: "Обязательно для заполнения"}}
                                    render={({onChange, value, ref, name}) => (
                                        <TextField
                                            label="Адрес проживания"
                                            placeholder="г. Владивосток, ул. Стрельникова 9"
                                            fullWidth
                                            inputProps={{maxLength: 128}}
                                            value={value}
                                            onChange={onChange}
                                            error={Boolean(errors?.[name])}
                                            helperText={errors?.[name]?.message}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </CardContent>
        </Card>
    )
}